import { QCalculateBets } from "./QCalculateBets";
import { QCalculateYourbetBets } from "./QCalculateYourbetBets";
import { QPlaceBets } from "./QPlaceBets";
import { QUpdatePurchases } from "./QUpdatePurchases";
import { QGetPurchases } from "./QGetPurchases";
export const QueryBuilder = {
    calculateBets: QCalculateBets,
    calculateYourbetBets: QCalculateYourbetBets,
    placeBets: QPlaceBets,
    updatePurchases: QUpdatePurchases,
    getPurchases: QGetPurchases
};
//# sourceMappingURL=index.js.map